.container {
  padding: var(--mirai-ui-space-M) var(--mirai-ui-space-M) 0 var(--mirai-ui-space-M);
}

.iframe {
  border: none;
  height: calc(var(--mirai-ui-space-XXL) * 10);
  width: 100%;
}
